export default __webpack_public_path__ + "static/media/bdswissGlobalReal04_downloadMT4.05f61b05.png";